

// React
import React from 'react';

import ReactExport from 'react-data-export';
import jMoment from 'moment-jalaali';
// UI
import {Button} from '@material-ui/core';


// Icon
import Icon from '@mdi/react';
import {mdiArrowDownBoldOutline, mdiProgressDownload} from '@mdi/js';
type Props = {
  ordersDispatch: any;
  data: any;
  filtersValues: any;
  loading: boolean;
};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function EXCEL(props: Props) {
  const handleCreateExcel = () => {
    props.ordersDispatch({...props.filtersValues, page: undefined, size: 2000});
  };
  const flattData = (data: any) => {
    const newData = data.map(
      ({
        customerLat,
        customerLon,
        receiptUrl,
        partnerId,
        fulfillmentWarehouseId,
        fulfillmentWarehouseAddress,childOrders,
        ...item
      }) => {
        return {
          ...item,
          deliveryDateFa:
            item.deliveryDate &&
            jMoment(item.deliveryDate, 'YYYY/M/D')
              .locale('fa')
              .format('jYY/jMM/jDD'),
          deliveryDate: item.deliveryDate,
          items: item.items?.map((item: any) => item.productName).join('& '),
          // items: item.items ? `${JSON.stringify(item?.items)?.replace(/['"]+/g, "'")}` : undefined,
          customerMobileNumber: item.customerMobileNumber + '',
          packages: undefined,
        };
      }
    );
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <ExcelFile
        element={
          <Button
            style={{marginLeft: '8px'}}
            size="large"
            variant="contained"
            color="primary"
            endIcon={<Icon path={mdiProgressDownload} size={'16px'} />}
            onClick={handleCreateExcel}
            disabled={props.loading}
          >
            EXCEL
          </Button>
        }
      >
        <ExcelSheet data={flattData(props.data)} name="orders">
          {props.data &&
            Object.entries(flattData(props.data)[0])?.map(el => {
              return <ExcelColumn label={el[0]} value={el[0]} />;
            })}
        </ExcelSheet>
      </ExcelFile>
      ) : (
        <Button
          style={{marginLeft: '8px'}}
          size="large"
          variant="contained"
          color="primary"
          endIcon={<Icon path={mdiArrowDownBoldOutline} size={'16px'} />}
          onClick={handleCreateExcel}
          disabled={props.loading}
        >
          EXCEL
        </Button>
      )}
    </>
  );
}

export default EXCEL;
